// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610091109/js/" + chunkId + "." + {"44":"7cf71c38","225":"431d5ac0","481":"52475b97","486":"db19078e","770":"756b8ba8"}[chunkId] + ".0.5194451882351271.chunk.js";
};